import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_STITCH_REQUEST = 'VIEW_STITCH_REQUEST';
export const VIEW_STITCH_SUCCESS = 'VIEW_STITCH_SUCCESS';
export const VIEW_STITCH_ERROR = 'VIEW_STITCH_ERROR';
export const RESET_VIEW_STITCH = 'RESET_VIEW_STITCH';


export const viewStitch = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: VIEW_STITCH_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/pattern/stitch/${id}`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: VIEW_STITCH_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_STITCH_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })

    }
}

export const resetviewStitch = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_STITCH
        })
    }
}



